import React from "react";
import "./Sevn.css";

import { appsData } from "../data/appsData";

const app = appsData.sevn;

export default function Sevn() {
  return (
    <div className="sevn-container">
      {/* HEADER */}
      <header className="sevn-header">
        <div className="sevn-header-inner">
          {/* Back Button */}
          <a
            href="/"
            title="Back"
            className="sevn-back-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="sevn-icon-sm"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <span className="sevn-mobile-only"></span>
          </a>

          {/* Logo & App Name */}
          <div className="sevn-header-center">
            <img src={app.iconPage} className="sevn-logo-sm" alt="Sevn logo" />
            <span className="font-semibold text-lg">Sevn</span>
          </div>

          {/* Empty div to balance spacing */}
          <div className="sevn-header-spacer sevn-mobile-only" />
        </div>
      </header>

      {/* HERO */}
      <section className="sevn-hero">
        {/* background glow */}
        <div className="sevn-glow-1" />
        <div className="sevn-glow-2" />
        <div className="sevn-glow-3" />

        <div className="sevn-hero-content">
          <img
            src={app.iconPage}
            alt="Sevn logo"
            className="sevn-hero-logo"
          />

          <h1 className="sevn-h1">
            Plan your entire week
            <br />
            <span className="sevn-text-muted">in seconds</span>
          </h1>

          <p className="sevn-hero-p1">
            Sevn is a beautifully simple weekly planner designed to keep your
            activities organized without distractions.
          </p>

          <p className="sevn-hero-p2">
            Minimal by design. No clutter. Just what you need to plan your week.
          </p>

          {/* store buttons */}
          <div className="sevn-buttons-wrap">
            <StoreButtons />
          </div>
        </div>
      </section>

      {/* SCREENSHOTS */}
      <section className="sevn-screenshots-section">
        <div className="sevn-inner">
          <h2 className="sevn-h2">
            A planner that stays out of your way
          </h2>

          <div className="sevn-screenshot-grid">
            {app.screenshots.map((screenshot, index) => (
              <div
                key={index}
                className="sevn-screenshot-card"
              >
                <img src={screenshot} alt={`Screenshot ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="sevn-features-section">
        <div className="sevn-inner">
          <h2 className="sevn-h2">
            Everything you need to plan your week
          </h2>

          <div className="sevn-feature-grid">
            <Feature
              title="Weekly Overview"
              text="See your entire week at a glance so you always know what’s next."
            />

            <Feature
              title="Unlimited Activities"
              text="Add as many activities and plans as you want with categories and notes."
            />

            <Feature
              title="Copy Previous Weeks"
              text="Reuse your structure and quickly build your routine."
            />

            <Feature
              title="Planner History"
              text="Look back at previous weeks and track how you spent your time."
            />

            <Feature
              title="Backup & Restore"
              text="Keep your plans safe and restore them anytime."
            />

            <Feature
              title="Lightning Fast"
              text="No loading. No clutter. Just open and plan."
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sevn-cta-section">
        <div className="sevn-cta-glow" />

        <div className="sevn-cta-content">
          <h2 className="sevn-cta-h2">
            Start planning your week today
          </h2>

          <p className="sevn-cta-text">
            Simple. Focused. Designed to keep you organized.
          </p>

          <div className="sevn-buttons-wrap">
            <StoreButtons />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="sevn-footer">
        <div className="sevn-footer-links">
          <a href={app.privacyLink} className="sevn-footer-link">
            Privacy Policy
          </a>

          <a href={app.termsLink} className="sevn-footer-link">
            Terms of Use
          </a>
        </div>

        <p>© {new Date().getFullYear()} Tilbo Apps</p>
      </footer>
    </div>
  );
}

function StoreButtons() {
  return (
    <>
      <a href={app.appStoreLink} target="_blank" rel="noopener noreferrer">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/9/91/Download_on_the_App_Store_RGB_blk.svg"
          className="sevn-store-btn"
          alt="App Store"
        />
      </a>

      <a href={app.playStoreLink} target="_blank" rel="noopener noreferrer">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          className="sevn-store-btn"
          alt="Play Store"
        />
      </a>
    </>
  );
}

function Feature({ title, text }) {
  return (
    <div className="sevn-feature-card">
      <h3 className="sevn-feature-title">{title}</h3>

      <p className="sevn-feature-text">{text}</p>
    </div>
  );
}
